import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PaymentDetailsActionService {
    private saveChangesSubject = new Subject<void>();
    saveChanges$ = this.saveChangesSubject.asObservable();

    /**
     * Emits an event to signal that the "Save Changes" action has been triggered.
     */
    triggerSaveChangesClick(): void {
        this.saveChangesSubject.next();
    }
}
